// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Components
import { Button } from "@components/Input";
// Assets
import { channelsSvg } from "assets";
import { arrowRightSvg } from "@assets";

class View extends Component {
  return = () => {
    const { history } = this.props;
    history.push("/integrations/directory");
  };

  integrateChannel = () => {
    const { history, location } = this.props;
    history.push(`${location.pathname}/create`);
  };

  render() {
    const { t } = this.props;
    return (
      <div className={"cen_integrations"}>
        <div className={"header"}>
          <div className={"header_content"}>
            <div onClick={() => this.return()} className={"header_action"}>
              {arrowRightSvg()}
            </div>
            <div className={"header_image"}>{channelsSvg("sunco")}</div>
            <div className={"header_title"}>
              <span className={"title"}>{t("channels.sunco.title")}</span>
              <span className={"description"}>{t("categories.customer")}</span>
            </div>
          </div>
          <div className={"header_actions"}>
            <Button
              type={"primary"}
              onClick={() => {
                this.integrateChannel("sunco");
              }}
              text={t("view.action_button")}
            />
          </div>
        </div>
        <div className={"content"}>
          <div className={"content_view"}>
            <span>{t("channels.sunco.description")}</span>
            <span
              dangerouslySetInnerHTML={{
                __html: t("channels.sunco.info").replaceAll(
                  "[br]",
                  "<br /><br />"
                )
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_view = connect(mapStateToProps)(View);

export default withTranslation("integrations")(withRouter(connect_view));
